import { render, staticRenderFns } from "./RealTimeThree.vue?vue&type=template&id=512469ff&scoped=true"
import script from "./RealTimeThree.vue?vue&type=script&lang=js"
export * from "./RealTimeThree.vue?vue&type=script&lang=js"
import style0 from "./RealTimeThree.vue?vue&type=style&index=0&id=512469ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512469ff",
  null
  
)

export default component.exports